import React from 'react';

const Dockerbanner = () => {
  return (
    <>
      <div className="breatcome_area7 d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breatcome_title"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dockerbanner;
